import api from '../../utils/api';
import AutocompleteAddress from '../../models/AutocompleteAddress';
import Constants from '../constants';

const AutocompleteActions = {
  autocomplete(partialAddress) {
    return (dispatch) =>
      dispatch(api.address.autocomplete(partialAddress)).then((response = {}) => {
        if (response.success && response.addresses) {
          const addressList = response.addresses.map((listing) => {
            return AutocompleteAddress(listing);
          });

          return dispatch({
            type: Constants.SET_AUTO_COMPLETE_ADDRESS_LIST,
            payload: {
              addressList,
            },
          });
        }
        return;
      });
  },
};

export default AutocompleteActions;
